import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"


const __default__ = {
  name: "App",
};

import Footer from "./components/TheFooter.vue";
import Header from "./components/TheHeader.vue";
import Messenger from "./components/TheMessenger.vue";
import Loader from "./components/TheLoader.vue";

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header),
    _createVNode(Messenger),
    _createVNode(Loader),
    (_ctx.$store.getters['keycloak/getStatusReady'])
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(Footer)
  ]))
}
}

})